module.exports = __webpack_public_path__ + "static/media/cara_happy_eyes_open_mouth_close.71caa8b9.png";